<template>

<app-inner class="list">

    <router-link :to="{name: 'Events/Event', params: { slug: item.slug }}" class="list-item" v-for="(item, index) in items" :key="index">

        <div class="list-item-image" :style="{backgroundImage: 'url(' + item.image + ')'}"></div>
                
        <div class="list-item-text">

            <div class="list-item-text-date">
                {{ item.date | formatDate('DD MMM YYYY') }}
                <template v-if="item.ends">
                - {{ item.ends | formatDate('DD MMM YYYY') }}
                </template> 
            </div>
            <div class="list-item-text-name">{{ item.name }}</div>
            <div class="list-item-text-description">{{ item.description }}</div>

        </div>

    </router-link>

    <app-pagination :pages="pages" :current="current" v-on:change="onPageChange" />

</app-inner>

</template>

<script>

export default {

    data: function() {

        return {
            is: {
                loading: false
            },
            current: 1,
            pages: 1,
            total: 0,
            items: []
        }

    },

    created: function() {

        if (this.$route.query.page) this.current = this.$route.query.page

        this.fetch()

    },

    methods: {

        onPageChange: function(page) {

			this.current = page

			this.fetch()

        },

        fetch: function() {

            this.is.loading = true

            this.$api.request('events', {
                page: this.current
            }).then(function(json) {

                this.total = json.total
                this.pages = json.pages 
                this.items = json.items

                if (json.page !== this.current) this.$router.replace({
                    query: {
                        page: this.current
                    }
                }).catch(function() {})

				if (this.current !== 1) window.scrollTo(0, 0)
				
                this.current = json.page 

                this.is.loading = false

            }.bind(this))

        }

    }

}

</script>

<style scoped>

.list {
    max-width: 800px;
}

.list-item {
    border: 1px solid var(--color-grey-light);
    border-radius: 4px;
    padding: 20px;
    margin-bottom: 20px;
    display: flex;
    flex-grow: 1;
    flex-direction: row;
}

.is-mobile .list-item {
    padding: 10px;
}

.is-desktop .list-item:hover {
    border-color: var(--color-grey-highlight);
}

.list-item-image {
    width: 160px;
    height: 160px;
    border-radius: 4px;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: contain;
    margin-right: 20px;
    flex-shrink: 0;
}

.is-mobile .list-item-image {
    width: 64px;
    height: 64px;
    margin-right: 10px;
}

.list-item-text {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}

.list-item-text-date {
    text-align: right;
    color: var(--color-grey);
    font-size: 12px;
    margin-bottom: 10px;
    text-transform: uppercase;
}

.list-item-text-name {
    color: var(--color-grey-dark);
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 10px;
    font-family: grueber,serif;
}

.is-tablet .list-item-text-name,
.is-mobile .list-item-text-name {
    font-size: 20px;
    line-height: 24px;
}

.list-item-text-description {
    color: var(--color-grey-dark);
    font-size: 14px;
    line-height: 18px;
    font-weight: 300;
}

</style>
